import { CookieDomain, RoverspaceDomain } from './types';

const LOCAL_HOST = 'localhost';
const LOCAL_ALIASES = [LOCAL_HOST, '127.0.0.1'];
const ROVER_LOCAL = 'rover.local';
const CIAF_LOCAL = 'ciaf.local';
const MADPAWS_LOCAL = 'madpaws.local';
const ROVER_CDN_STAGING = '.roverstaging.com';
const CIAF_STAGING = '.catinaflat.dev';
const MADPAWS_STAGING = '.madpaws.dev';
const ROVER_COM = '.rover.com';
const MADPAWS_COM_AU = '.madpaws.com.au';
const GITHUB_PREVIEW = '.app.github.dev';
// Roverspaces (Coder) serve on devcontainer.<workspace>.<owner>.coder
const ROVERSPACE_SUFFIX = '.coder';

// .co.uk must come before .com so it matches first
const CIAF_PRODUCTION_DOMAINS: CookieDomain[] = [
  '.catinaflat.co.uk',
  '.catinaflat.com',
  '.catinaflat.de',
  '.catinaflat.at',
  '.catinaflat.be',
  '.catinaflat.fr',
  '.catinaflat.ie',
  '.catinaflat.nl',
  '.catinaflat.ch',
  '.catinaflat.es',
  '.catinaflat.ca',
];

const getCookieDomain = (rawHost: string): CookieDomain => {
  // Server callers pass the Host header, which carries a port; browsers pass
  // window.location.hostname, which never does. Normalize so both agree.
  const host = rawHost.split(':')[0];

  if (LOCAL_ALIASES.includes(host)) {
    return LOCAL_HOST;
  }

  if (host === ROVER_LOCAL) {
    return ROVER_LOCAL;
  }

  if (host === CIAF_LOCAL) {
    return CIAF_LOCAL;
  }

  if (host === MADPAWS_LOCAL) {
    return MADPAWS_LOCAL;
  }

  if (host.endsWith(ROVER_CDN_STAGING)) {
    return ROVER_CDN_STAGING;
  }

  if (host.endsWith(CIAF_STAGING)) {
    return CIAF_STAGING;
  }

  if (host.endsWith(MADPAWS_STAGING)) {
    return MADPAWS_STAGING;
  }

  if (host === 'madpaws.com.au' || host.endsWith(MADPAWS_COM_AU)) {
    return MADPAWS_COM_AU;
  }

  if (host.includes(GITHUB_PREVIEW)) {
    return GITHUB_PREVIEW;
  }

  // `coder` is a private TLD with no Public Suffix List entry, so it falls under
  // the PSL's default `*` rule and browsers reject a cookie scoped to `.coder`.
  // Scope to the workspace host itself instead, as we do for the other dev hosts.
  if (host.endsWith(ROVERSPACE_SUFFIX)) {
    return host as RoverspaceDomain;
  }

  for (const domain of CIAF_PRODUCTION_DOMAINS) {
    if (host.endsWith(domain)) {
      return domain;
    }
  }

  return ROVER_COM;
};

export default getCookieDomain;
